export default {
  locale: [
    {
      title: 'Afrikaans',
      value: 'af_ZA',
      icon: 'za'
    },
    {
      title: 'Arabic',
      value: 'ar_AR',
      icon: 'ar'
    },
    {
      title: 'Azerbaijani',
      value: 'az_AZ',
      icon: 'az'
    },
    {
      title: 'Belarusian',
      value: 'be_BY',
      icon: 'by'
    },
    {
      title: 'Bulgarian',
      value: 'bg_BG',
      icon: 'bg'
    },
    {
      title: 'Bengali',
      value: 'bn_IN',
      icon: 'in'
    },
    {
      title: 'Bosnian',
      value: 'bs_BA',
      icon: 'ba'
    },
    {
      title: 'Catalan',
      value: 'ca_ES',
      icon: 'es'
    },
    {
      title: 'Czech',
      value: 'cs_CZ',
      icon: 'cz'
    },
    {
      title: 'Welsh',
      value: 'cy_GB',
      icon: 'gb'
    },
    {
      title: 'Danish',
      value: 'da_DK',
      icon: 'dk'
    },
    {
      title: 'German',
      value: 'de_DE',
      icon: 'de'
    },
    {
      title: 'Greek',
      value: 'el_GR',
      icon: 'gr'
    },
    {
      title: 'English (UK)',
      value: 'en_GB',
      icon: 'gb'
    },
    {
      title: 'English (Pirate)',
      value: 'en_PI',
      icon: 'pi'
    },
    {
      title: 'English (Upside Down)',
      value: 'en_UD',
      icon: 'ud'
    },
    {
      title: 'English (US)',
      value: 'en_US',
      icon: 'us'
    },
    {
      title: 'Esperanto',
      value: 'eo_EO',
      icon: 'eo'
    },
    {
      title: 'Spanish (Spain)',
      value: 'es_ES',
      icon: 'es'
    },
    {
      title: 'Spanish',
      value: 'es_LA',
      icon: 'la'
    },
    {
      title: 'Estonian',
      value: 'et_EE',
      icon: 'ee'
    },
    {
      title: 'Basque',
      value: 'eu_ES',
      icon: 'es'
    },
    {
      title: 'Persian',
      value: 'fa_IR',
      icon: 'ir'
    },
    {
      title: 'Leet Speak',
      value: 'fb_LT',
      icon: 'lt'
    },
    {
      title: 'Finnish',
      value: 'fi_FI',
      icon: 'fi'
    },
    {
      title: 'Faroese',
      value: 'fo_FO',
      icon: 'fo'
    },
    {
      title: 'French (Canada)',
      value: 'fr_CA',
      icon: 'ca'
    },
    {
      title: 'French (France)',
      value: 'fr_FR',
      icon: 'fr'
    },
    {
      title: 'Frisian',
      value: 'fy_NL',
      icon: 'nl'
    },
    {
      title: 'Irish',
      value: 'ga_IE',
      icon: 'ie'
    },
    {
      title: 'Galician',
      value: 'gl_ES',
      icon: 'es'
    },
    {
      title: 'Hebrew',
      value: 'he_IL',
      icon: 'il'
    },
    {
      title: 'Hindi',
      value: 'hi_IN',
      icon: 'in'
    },
    {
      title: 'Croatian',
      value: 'hr_HR',
      icon: 'hr'
    },
    {
      title: 'Hungarian',
      value: 'hu_HU',
      icon: 'hu'
    },
    {
      title: 'Armenian',
      value: 'hy_AM',
      icon: 'am'
    },
    {
      title: 'Indonesian',
      value: 'id_ID',
      icon: 'id'
    },
    {
      title: 'Icelandic',
      value: 'is_IS',
      icon: 'is'
    },
    {
      title: 'Italian',
      value: 'it_IT',
      icon: 'it'
    },
    {
      title: 'Japanese',
      value: 'ja_JP',
      icon: 'jp'
    },
    {
      title: 'Georgian',
      value: 'ka_GE',
      icon: 'ge'
    },
    {
      title: 'Khmer',
      value: 'km_KH',
      icon: 'kh'
    },
    {
      title: 'Korean',
      value: 'ko_KR',
      icon: 'kr'
    },
    {
      title: 'Kurdish',
      value: 'ku_TR',
      icon: 'tr'
    },
    {
      title: 'Latin',
      value: 'la_VA',
      icon: 'va'
    },
    {
      title: 'Lithuanian',
      value: 'lt_LT',
      icon: 'lt'
    },
    {
      title: 'Latvian',
      value: 'lv_LV',
      icon: 'lv'
    },
    {
      title: 'Macedonian',
      value: 'mk_MK',
      icon: 'mk'
    },
    {
      title: 'Malayalam',
      value: 'ml_IN',
      icon: 'in'
    },
    {
      title: 'Malay',
      value: 'ms_MY',
      icon: 'my'
    },
    {
      title: 'Norwegian (bokmal)',
      value: 'nb_NO',
      icon: 'no'
    },
    {
      title: 'Nepali',
      value: 'ne_NP',
      icon: 'np'
    },
    {
      title: 'Dutch',
      value: 'nl_NL',
      icon: 'nl'
    },
    {
      title: 'Norwegian (nynorsk)',
      value: 'nn_NO',
      icon: 'no'
    },
    {
      title: 'Punjabi',
      value: 'pa_IN',
      icon: 'in'
    },
    {
      title: 'Polish',
      value: 'pl_PL',
      icon: 'pl'
    },
    {
      title: 'Pashto',
      value: 'ps_AF',
      icon: 'af'
    },
    {
      title: 'Portuguese (Brazil)',
      value: 'pt_BR',
      icon: 'br'
    },
    {
      title: 'Portuguese (Portugal)',
      value: 'pt_PT',
      icon: 'pt'
    },
    {
      title: 'Romanian',
      value: 'ro_RO',
      icon: 'ro'
    },
    {
      title: 'Russian',
      value: 'ru_RU',
      icon: 'ru'
    },
    {
      title: 'Slovak',
      value: 'sk_SK',
      icon: 'sk'
    },
    {
      title: 'Slovenian',
      value: 'sl_SI',
      icon: 'si'
    },
    {
      title: 'Albanian',
      value: 'sq_AL',
      icon: 'al'
    },
    {
      title: 'Serbian',
      value: 'sr_RS',
      icon: 'rs'
    },
    {
      title: 'Swedish',
      value: 'sv_SE',
      icon: 'se'
    },
    {
      title: 'Swahili',
      value: 'sw_KE',
      icon: 'ke'
    },
    {
      title: 'Tamil',
      value: 'ta_IN',
      icon: 'in'
    },
    {
      title: 'Telugu',
      value: 'te_IN',
      icon: 'in'
    },
    {
      title: 'Thai',
      value: 'th_TH',
      icon: 'th'
    },
    {
      title: 'Filipino',
      value: 'tl_PH',
      icon: 'ph'
    },
    {
      title: 'Turkish',
      value: 'tr_TR',
      icon: 'tr'
    },
    {
      title: 'Ukrainian',
      value: 'uk_UA',
      icon: 'ua'
    },
    {
      title: 'Vietnamese',
      value: 'vi_VN',
      icon: 'vn'
    },
    {
      title: 'Simplified Chinese (China)',
      value: 'zh_CN',
      icon: 'cn'
    },
    {
      title: 'Traditional Chinese (Hong Kong)',
      value: 'zh_HK',
      icon: 'hk'
    },
    {
      title: 'Traditional Chinese (Taiwan)',
      value: 'zh_TW',
      icon: 'tw'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/config/locale.js